import React, { useEffect } from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import ParticipantWindowHeader from './ParticipantWindowHeader/ParticipantWindowHeader';
import clsx from 'clsx';
import useChatContext from '../../hooks/useChatContext/useChatContext';
import { ANIMATION_DURATION } from '../Buttons/ToggleChatButton/ToggleChatButton';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import useParticipantsContext from '../../hooks/useParticipantsContext/useParticipantsContext';
import useSelectedParticipant from '../VideoProvider/useSelectedParticipant/useSelectedParticipant';
import useScreenShareParticipant from '../../hooks/useScreenShareParticipant/useScreenShareParticipant';
import useMainParticipant from '../../hooks/useMainParticipant/useMainParticipant';
import { useAppState } from '../../state';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    participantWindowContainer: {
      background: '#FFFFFF',
      zIndex: 9,
      display: 'flex',
      flexDirection: 'column',
      borderLeft: '1px solid #E4E7E9',
      [theme.breakpoints.down('sm')]: {
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 100,
      },
    },
    hide: {
      display: 'none',
    },
  })
);

// In this component, we are toggling the visibility of the ChatWindow with CSS instead of
// conditionally rendering the component in the DOM. This is done so that the ChatWindow is
// not unmounted while a file upload is in progress.

export default function ParticipantWindow() {
  const classes = useStyles();
  const { isParticipantWindowOpen } = useChatContext();

  const { room } = useVideoContext();
  const localParticipant = room!.localParticipant;
  const { user } = useAppState();
  const { speakerViewParticipants } = useParticipantsContext();
  const [selectedParticipant, setSelectedParticipant] = useSelectedParticipant();
  const screenShareParticipant = useScreenShareParticipant();
  const mainParticipant = useMainParticipant();
  const isRemoteParticipantScreenSharing = screenShareParticipant && screenShareParticipant !== localParticipant;

  return (
    <aside className={clsx(classes.participantWindowContainer, { [classes.hide]: !isParticipantWindowOpen })}>
      <ParticipantWindowHeader />
      <ul style={{ overflowY: 'scroll' }}>
        <li>
          {localParticipant.identity} <label style={{ color: 'darkgreen' }}>(Csatlakozva)</label>
        </li>
        {user?.participants.map(identity => {
          const isConnected =
            speakerViewParticipants.findIndex(e => e.identity === identity) > -1 ? (
              <label style={{ color: 'darkgreen' }}>(Csatlakozva)</label>
            ) : (
              <label style={{ color: 'darkred' }}>(Nincs csatlakozva)</label>
            );

          if (localParticipant.identity === identity) {
            return null;
          }

          return (
            <li>
              {identity} {isConnected}
            </li>
          );
        })}
      </ul>
    </aside>
  );
}
